interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) pages.push(i);

  return (
    <nav
      aria-label="分页导航"
      className="mt-8 flex items-center justify-center gap-2 flex-wrap"
    >
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
        className="flex items-center gap-1 rounded-md border border-background-700 px-3 py-1.5 text-sm text-foreground-200 transition-colors hover:border-primary-500 hover:text-foreground-50 disabled:cursor-not-allowed disabled:opacity-40 whitespace-nowrap cursor-pointer"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          aria-current={p === page ? "page" : undefined}
          className={`h-9 w-9 rounded-md text-sm transition-colors cursor-pointer ${
            p === page
              ? "bg-primary-500 text-foreground-50 font-medium"
              : "border border-background-700 text-foreground-300 hover:border-primary-500 hover:text-foreground-50"
          }`}
        >
          {p}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page >= totalPages}
        className="flex items-center gap-1 rounded-md border border-background-700 px-3 py-1.5 text-sm text-foreground-200 transition-colors hover:border-primary-500 hover:text-foreground-50 disabled:cursor-not-allowed disabled:opacity-40 whitespace-nowrap cursor-pointer"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}